module.exports = __webpack_public_path__ + "img/hr-pump-north.1033c2c1.png";